import { ActionType, AssetType, ChangeMediaOperationType, ChangeMediaType, EventToolBarJudge, EventToolBarType, PLAY_INFO_ID, SenderType } from '@/const/mission';
import { IAssets } from '@/interface';
import { getRichLocalPath } from '@/material/form-upload/change-data';
import { UserResourceDetail } from '@/services/library';

import { eventDefaultValue } from '../../../toolbar/default';
import { ToolbarItem } from '../../../toolbar/toolbar';


export interface IResource {
  imageList: UserResourceDetail & { exclName?: string }[];
  videoList: UserResourceDetail & { exclName?: string }[];
  audioList: UserResourceDetail & { exclName?: string }[];
  spineList: UserResourceDetail & { exclName?: string }[];
}

// 返回布尔值
const findTooBar = (type: EventToolBarType, toolBar?: ToolbarItem[]): ToolbarItem | undefined => {
  if (!toolBar || !Array.isArray(toolBar)) return undefined;
  return toolBar.find(item => item?.key === type);
};

const filterResourceByName = (
  text: string,
  list: (UserResourceDetail & { exclName?: string })[],
) => list.find(item => item?.exclName === text);

const getDubObject = (execValue: { match: string; text: string; textDubUrlName?: string }, resource?: IResource) => {
  const exclResourceByText = filterResourceByName(execValue?.textDubUrlName || '', resource?.audioList || []);
  return {
    dubUrl:
    {
      url: exclResourceByText?.url,
      localPath: getRichLocalPath(exclResourceByText?.url || ''),
      name: exclResourceByText?.resourceName || execValue?.textDubUrlName || '',
    },
  };
};

// 生成对应的剧本事件数据
export const getParsedData = (
  execValue: { match: string; text: string; textDubUrlName?: string },
  matchBotList: (matchText: string) => string,
  matchPropList: (matchText: string) => IAssets,
  resource?: IResource,
  toolBar?: ToolbarItem[],
) => {
  if (
    !execValue.match || execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_SYSTEM])
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_SYSTEM];

    return {
      ...temp,
      message: {
        ...temp?.message,
        text: {
          ...temp?.message?.text,
          text: execValue.text,
          ...getDubObject(execValue, resource),
        },
      },
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_BOT])
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_BOT];
    return {
      ...temp,
      message: {
        ...temp?.message,
        text: {
          ...temp?.message?.text,
          text: execValue.text,
          ...getDubObject(execValue, resource),
        },
      },
    };
  }

  if (
    (execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_PROPS])
      || execValue.match?.includes(EventToolBarJudge.props))
    && findTooBar(EventToolBarType.ADD_PROPS, toolBar)
  ) {
    const matchValue = matchPropList(execValue.text);
    const temp = eventDefaultValue[EventToolBarType.ADD_PROPS];
    return {
      ...temp,
      action: {
        type: ActionType.ACTION_TYPE_SHOWCARD,
        showAsset: {
          type: AssetType.ASSET_TYPE_ITEMSCARD,
          itemCard: {
            id: matchValue?.id,
            name: matchValue?.name,
          },
        },
      },
    };
  }

  // 移除顺序必须在正常匹配之前
  if (execValue.match?.includes(EventToolBarJudge.removeSpine)) {
    const temp = eventDefaultValue[EventToolBarType.ADD_SPINE_FORE_IMAGE];
    return {
      ...temp,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          type: ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE,
          operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
          spine: {

          },
        },
      },
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge.spine)
    || execValue.match?.includes(EventToolBarJudge.Spine)
    || execValue.match?.includes(EventToolBarJudge.SpineText)
    || execValue.match?.includes(EventToolBarJudge.SPineTextTrim)
  ) {
    const exclResourceByText = filterResourceByName(execValue.text, resource?.spineList || []);
    const temp = eventDefaultValue[EventToolBarType.ADD_SPINE_FORE_IMAGE];
    return {
      ...temp,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          type: ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE,
          operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
          spine: {
            ...exclResourceByText?.spine,
          },
        },
      },
    };
  }

  if (execValue.match?.includes(EventToolBarJudge[EventToolBarType.REMOVE_MULTI_CHARACTER])) {
    const temp = eventDefaultValue[EventToolBarType.ADD_MULTI_CHARACTER];
    return {
      ...temp,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          type: ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER,
          operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
          multiVerticalPainting: [],
        },
      },
    };
  }

  if (execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_MULTI_CHARACTER])) {
    const temp = eventDefaultValue[EventToolBarType.ADD_SPINE_FORE_IMAGE];
    return {
      ...temp,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          type: ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER,
          operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
          multiVerticalPainting: [],
        },
      },
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.REMOVE_FORE_IMAGE])
    || execValue.match?.includes(EventToolBarJudge.removeSingleCharacter)
  ) {
    const temp = eventDefaultValue[EventToolBarType.REMOVE_FORE_IMAGE];
    return {
      ...temp,
      action: {
        ...temp.action,
      },
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_BG_IMAGE])
    || execValue.match?.includes(EventToolBarJudge.image)
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_BG_IMAGE];
    const exclResourceByText = filterResourceByName(execValue.text, resource?.imageList || []);
    let autoMatchVal = {
      ...temp.action?.changeMedia?.backgroundImage,
    };
    if (exclResourceByText?.url) {
      autoMatchVal = {
        ...autoMatchVal,
        url: {
          url: exclResourceByText?.url,
          localPath: getRichLocalPath(exclResourceByText?.url || ''),
          name: exclResourceByText?.resourceName || '',
        },
        showType: 1,
        sample: {
          primary: '',
          complementary: '',
        },
        height: 0,
        width: 0,
      };
    }
    const action = {
      ...temp.action,
      changeMedia: {
        ...temp.action?.changeMedia,
        backgroundImage: {
          ...temp.action?.changeMedia?.backgroundImage,
          ...autoMatchVal,
          promptText: execValue.text,
        },
      },
    };
    return {
      ...temp,
      action,
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_FORE_IMAGE])
    || execValue.match?.includes(EventToolBarJudge.foreImage)
    || execValue.match?.includes(EventToolBarJudge.singleCharacter)
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_FORE_IMAGE];
    const exclResourceByText = filterResourceByName(execValue.text, resource?.imageList || []);
    let autoMatchVal = {
      ...temp.action?.changeMedia?.backgroundImage,
    };
    if (exclResourceByText?.url) {
      autoMatchVal = {
        ...autoMatchVal,
        url: {
          url: exclResourceByText?.url,
          localPath: getRichLocalPath(exclResourceByText?.url || ''),
          name: exclResourceByText?.resourceName || '',
        },
        showType: 1,
        // "sample": {
        //   "primary": "",
        //   "complementary": ""
        // },
      };
    }
    const action = {
      ...temp.action,
      changeMedia: {
        ...temp.action?.changeMedia,
        foregroundImage: {
          ...temp.action?.changeMedia?.foregroundImage,
          ...autoMatchVal,
          promptText: execValue.text,
        },
      },
    };
    return {
      ...temp,
      action,
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.STOP_AUDIO])
    || execValue.match?.includes(EventToolBarJudge.stopbgm)
    || execValue.match?.includes(EventToolBarJudge.stopBGM)
    || execValue.match?.includes(EventToolBarJudge.stopAudio)
    || execValue.match?.includes(EventToolBarJudge.stopMusic)
  ) {
    const temp = eventDefaultValue[EventToolBarType.STOP_AUDIO];
    return {
      ...temp,
      action: {
        ...temp.action,
      },
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_AUDIO])
    || execValue.match?.includes(EventToolBarJudge.bgm)
    || execValue.match?.includes(EventToolBarJudge.BGM)
    || execValue.match?.includes(EventToolBarJudge.audio)
    || execValue.match?.includes(EventToolBarJudge.music)
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_AUDIO];
    const exclResourceByText = filterResourceByName(execValue.text, resource?.audioList || []);
    let autoMatchVal = {
      ...temp.action?.changeMedia?.bgmAudio,
    };
    if (exclResourceByText?.url) {
      autoMatchVal = {
        ...autoMatchVal,
        url: {
          url: exclResourceByText?.url,
          localPath: getRichLocalPath(exclResourceByText?.url || ''),
          name: exclResourceByText?.resourceName || '',
        },
        showType: 1,
      };
    }

    const action = {
      ...temp.action,
      changeMedia: {
        ...temp.action?.changeMedia,
        bgmAudio: {
          ...temp.action?.changeMedia?.bgmAudio,
          ...autoMatchVal,
          promptText: execValue.text,
        },
      },
    };
    return {
      ...temp,
      action,
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_SOUND_EFFECT])
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_SOUND_EFFECT];
    const exclResourceByText = filterResourceByName(execValue.text, resource?.audioList || []);
    let autoMatchVal = {
      ...temp.action?.changeMedia?.bgmAudio,
    };
    if (exclResourceByText?.url) {
      autoMatchVal = {
        ...autoMatchVal,
        url: {
          url: exclResourceByText?.url,
          localPath: getRichLocalPath(exclResourceByText?.url || ''),
          name: exclResourceByText?.resourceName || '',
        },
        showType: 1,
      };
    }
    const action = {
      ...temp.action,
      changeMedia: {
        ...temp.action?.changeMedia,
        bgmAudio: {
          ...temp.action?.changeMedia?.bgmAudio,
          ...autoMatchVal,
          promptText: execValue.text,
        },
      },
    };
    return {
      ...temp,
      action,
    };
  }

  // 优先处理背景视频
  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_BG_VIDEO])
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_BG_VIDEO];
    const exclResourceByText = filterResourceByName(execValue.text, resource?.videoList || []);
    let autoMatchVal = {
      ...temp.action?.changeMedia?.backgroundVideo,
    };
    if (exclResourceByText?.url) {
      autoMatchVal = {
        ...autoMatchVal,
        url: {
          url: exclResourceByText?.url,
          localPath: getRichLocalPath(exclResourceByText?.url || ''),
          name: exclResourceByText?.resourceName || '',
        },
        showType: 1,
      };
    }

    const action = {
      ...temp.action,
      changeMedia: {
        ...temp.action?.changeMedia,
        backgroundVideo: {
          ...temp.action?.changeMedia?.backgroundVideo,
          ...autoMatchVal,
          promptText: execValue.text,
        },
      },
    };
    return {
      ...temp,
      action,
    };
  }

  if (
    execValue.match?.includes(EventToolBarJudge[EventToolBarType.ADD_VIDEO])
  ) {
    const temp = eventDefaultValue[EventToolBarType.ADD_VIDEO];
    const exclResourceByText = filterResourceByName(execValue.text, resource?.videoList || []);
    let autoMatchVal = {
      ...temp.action?.changeMedia?.fullVideo,
    };
    if (exclResourceByText?.url) {
      autoMatchVal = {
        ...autoMatchVal,
        url: {
          url: exclResourceByText?.url,
          localPath: getRichLocalPath(exclResourceByText?.url || ''),
          name: exclResourceByText?.resourceName || '',
        },
        showType: 1,
      };
    }

    const action = {
      ...temp.action,
      changeMedia: {
        ...temp.action?.changeMedia,
        fullVideo: {
          ...temp.action?.changeMedia?.fullVideo,
          ...autoMatchVal,
          promptText: execValue.text,
        },
      },
    };
    return {
      ...temp,
      action,
    };
  }

  const matchSenderId = matchBotList(execValue.match);
  // 默认使用bot解析兜底
  const temp = eventDefaultValue[EventToolBarType.ADD_BOT];
  return {
    ...temp,
    message: {
      ...temp?.message,
      text: {
        ...temp?.message?.text,
        text: execValue.text,
        ...getDubObject(execValue, resource),
      },
      sender: {
        type:
          matchSenderId === PLAY_INFO_ID ? SenderType.USER : SenderType.BOT,
        senderId: matchSenderId,
      },
    },
  };
};
